import { createAction } from 'redux-actions';

import types from './types';

const _setDataAttr = createAction(types.SET_DATA_ATTR);
const setDataAttr = (name, value) => _setDataAttr({ name, value });
const validateCard = createAction(types.VALIDATE_CARD);
const setCardNumber = createAction(types.SET_CARD_NUMBER);
const getSavedCard = createAction(types.GET_SAVED_CARD);
const setSavedCards = createAction(types.SET_SAVED_CARD);
const setSelectedCard = createAction(types.SET_SELECTED_CARD);
const setLoadingSavedCard = createAction(types.SET_SAVED_CARD_LOADED);
const setValidationError = createAction(types.SET_SWIPE_TO_VALIDATION);
const setLoyaltyPointBalance = createAction(types.SET_LOYALTY_POINT_BALANCE);
const getLoyaltyPointBalance = createAction(types.GET_LOYALTY_POINT_BALANCE);
const setLoyaltyEmployeePointBalance = createAction(types.SET_LOYALTY_EMPLOYEE_POINT_BALANCE)
const setSwipeOrderConfirmationCode = createAction(types.SET_SWIPE_TO_BUY_ORDER_CONFIRMATION_CODE);
const getFormData = createAction(types.FETCH_FORM_DATA);
const setSwipeToBuyError = createAction(types.SET_SWIPE_TO_BUY_ERROR);
const setSwipeToBuyErrorType = createAction(types.SET_SWIPE_TO_BUY_ERROR_TYPE);

export default {
    validateCard,
    setCardNumber,
    setDataAttr,
    getSavedCard,
    setSavedCards,
    getLoyaltyPointBalance,
    setLoyaltyEmployeePointBalance,
    setLoyaltyPointBalance,
    setSelectedCard,
    setLoadingSavedCard,
    setValidationError,
    setSwipeOrderConfirmationCode,
    getFormData,
    setSwipeToBuyError,
    setSwipeToBuyErrorType,
};
